import React, { Component } from "react";
import { get,post } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import globalVariables from "../../custom_libraries/globalVariables";
import WebLogo from '../../assets/Artboard 1Bonus.png';
import { Link } from "react-router-dom";

class AddDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deviceName: "",
            deviceType: "", // default null to select from list of valid options only
            client: "", 
            site_list:[],
            device_type_list:[],
            ipAddress: "",
            protocol: "",
            portNumber: "",
            rtsp_port: "",
            deviceUsername: "",
            devicePassword: "",
            status: "active", // Default value
            storageHealth: "ok", // Default value
            deviceHealth: "healthy", // Default value
            warning: false,
            success: false,
            error:false,
            error1:false,
            warning1:false,

            showModal: false, // Controls modal visibility
            responseMessage: "", // Stores the response message
            response_data: {},

            open_progress_bar: false,
        };
    }

    componentDidMount() {
        // Retrieve SITE_ID from localStorage
        const siteId = localStorage.getItem(globalVariables.SITE_ID);
       this.getSitesList(); 
       // Set the client state to the retrieved siteId
       if (siteId) {
        this.setState({ client: siteId });
        }
       this.fetchDeviceTypes();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.warning !== prevState.warning ||
            this.state.error !== prevState.error ||
            this.state.error1 !== prevState.error1 ||
            this.state.warning1 !== prevState.warning1 ||
            this.state.success !== prevState.success
        ) {
            if (
                this.state.warning ||
                this.state.error ||
                this.state.error1 ||
                this.state.warning1 ||
                this.state.success
            ) {
                setTimeout(() => {
                    this.setState({
                        warning: false,
                        error: false,
                        error1: false,
                        warning1: false,
                        success: false,
                    });
                }, 4000); // 1 second
            }
        }
    }

    getSitesList = async () => {
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }

            console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
            const response = await get(urls.GET_SITES_BY_USER, headers);
            console.log("response ===> ", response);

            if (!response) {
                console.error("Failed to fetch site list.");
                this.setState({ site_list: [] });
                return;
            }

            this.setState({ site_list: response });
        } catch (error) {
            console.error("Error in getSitesList:", error);
            this.setState({ site_list: [] });
        }
    };

    // getClientsList = async () => {   //fetch registered/added clients
    //     try {
    //         console.log("Fetching data from:", urls.GET_CLIENTS);
    //         const response = await get(urls.GET_CLIENTS);
    //         console.log("Client list Response in Adddevice-----:", response);
    
    //         if (!response) {
    //             console.error("Failed to fetch client list.");
    //             this.setState({ site_list: [] });
    //             return;
    //         }
    
    //         this.setState({ site_list: response });
    //         console.log("Updated state with client list:", this.state.site_list);
    //     } catch (error) {
    //         console.error("Error in getClientsList:", error);
    //         this.setState({ site_list: [] });
    //     }
        
        
    // };

    fetchDeviceTypes = async () => {
            try {
                let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
                console.log("--------auth tocken---------", access_tocken);
                let headers = {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${access_tocken}`
                }
                console.log("Fetching data from:", urls.DEVICE_TYPE_LIST);
                const response = await get(urls.DEVICE_TYPE_LIST, headers);
                console.log("Client list Response in Adddevice-----:", response);
        
                if (!response || !Array.isArray(response)) {
                    console.error("Invalid response format or empty list.");
                    this.setState({ device_type_list: [] });
                    return;
                }
        
                this.setState({ device_type_list: response }); // Directly use the array from your response
                console.log("Updated state with device types list:", this.state.device_type_list);
            } catch (error) {
                console.error("Error in fetchDeviceTypes:", error);
                this.setState({ device_type_list: [] });
            }
        }
        
         // Handle input change of all form fields
    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    // Handle form submission
    handleSubmit = async (e) => {
        e.preventDefault();
        this.startLoading()
        const {
            deviceName,
            deviceType,
            client,
            ipAddress,
            protocol,
            portNumber,
            deviceUsername,
            devicePassword,
            rtsp_port,
          } = this.state;

        // Validation
        if (!deviceName || !client || !ipAddress) {
            this.setState({ warning: true});
            this.stopLoading()
            return;
        }

        // Prepare payload
        let deviceData = {
            device_name: deviceName,
            device_type: deviceType,
            sitedb: client,
            ip_address: ipAddress,
            protocol: protocol?.toLowerCase().replace('://', ''), // Convert to lowercase and remove '://'
            port_number: portNumber,
            device_username: deviceUsername,
            device_password: devicePassword,
            rtsp_port: rtsp_port,
            // hd_capacity_alert:"1",
            policy_template_id : "1",

            // status:'',
            // storage_health:'',
            // total_cameras:'',
            // chl_max_count:'',
            // cameras_down:'',
            // device_health:''

            
        };
        const data = JSON.stringify(deviceData)
        console.log("data---",data)

        try{
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            // console.log("--------auth tocken---------", access_tocken);
            let headers = {
                // 'content-type': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_tocken}`
            }
            
            let response = await post(urls.CREATE_DEVICE, data, headers)

            console.log("url",urls.CREATE_DEVICE)
            console.log("data res",response)

            if(response!==false){
                if(response.responseMessage.includes("Device with IP") &&
                response.responseMessage.includes("already exists")){
                    this.setState({ error1: true, responseMessage: response.responseMessage }, this.stopLoading);
                    return;
                }
                else if(response.responseMessage === "Enter a valid IPv4 or IPv6 address."){
                    this.setState({ error1: true, responseMessage: response.responseMessage }, this.stopLoading);
                    return;
                }
            
                else {this.setState({
                    success: true,
                    showModal: true,
                    responseMessage: response.responseMessage,
                    response_data: response.response_data,
                });
            } 
            }
            else if(response === false){

                // Add status: "inactive" to the deviceData object to set the status of not reachable device as inactive
                deviceData.status = "inactive";
                // Convert the updated deviceData to JSON
                const updatedData = JSON.stringify(deviceData);
                console.log("updatedData in 2nd add device api----",updatedData);

                let response1 = await post(urls.ADD_DEVICE, updatedData, headers)

                if(response1!==false){
                    if(response1.responseMessage.includes("Device with IP") &&
                    response1.responseMessage.includes("already exists")){
                        this.setState({ error1: true, responseMessage: response1.responseMessage }, this.stopLoading);
                        return;
                    }
                    else if(response1.ip_address && Array.isArray(response1.ip_address) && response1.ip_address[0] === "Enter a valid IPv4 or IPv6 address."){
                        console.log("response1.ip_address-------",response1.ip_address);
                        this.setState({ error1: true, responseMessage: response1.ip_address }, this.stopLoading);
                    return;
                    }
                    else {this.setState({
                        warning1: true,
                        responseMessage: response1.responseMessage,
                        response_data: response1.response_data,
                    });
                    }
                }

                // console.log("url",urls.ADD_DEVICE)
                console.log("data res",response1)
                // this.setState({ warning1: true});
               
            }
        }catch (error) {
            console.error('Error:', error);
            this.setState({ error: true });
        } finally {
            this.stopLoading();
        }
    };

    startLoading = () => {
        console.log("startloading")
    
        this.setState({ open_progress_bar: true })
    }
    
    stopLoading = () => {
        this.setState({ open_progress_bar: false })
    }

    // Method to handle modal close
    handleCloseModal = () => {
        this.setState({ showModal: false }, () => {
            // Reload the page after modal is closed
            window.location.reload();
        });
    };

    render() {
        const {
            deviceName,
            deviceType,
            client,
            ipAddress,
            protocol,
            portNumber,
            rtsp_port,
            deviceUsername,
            devicePassword,
            warning,
            warning1,
            error,
            error1,
            success,
            site_list,
            device_type_list,
            showModal, responseMessage, response_data
        } = this.state;

        //const deviceTypes = ["NVR-1", "NVR-2", "NVR-3"]; // Hardcoded options for now
        // const clients = ["Client-1", "Client-2"]; // Hardcoded clients

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{height:'40px', backgroundColor:'#f3f3f3', color:'black', marginLeft: '11%', fontSize:'16px', fontWeight:'bold', display:'flex', alignItems:'center', marginBottom:'8px'}}>
                         <Link to="/system-overview"><span style={{ paddingLeft:'20px'}}>Dashboard</span> </Link>&ensp; &gt; &ensp;Device Manager &ensp;&gt;&ensp; Add Device
                      </div>
                <div style={{ flex: '1', marginLeft:'20%', marginTop:'2%', padding: '2px', overflowY: 'auto' }}>
                    <div className="client-container">
                        <div className="form-section" >
                            <h3>Add New Device</h3>

                            {warning ? (
                                <Alert severity="warning">Please fill all the required fields.</Alert>
                            ) : error ? (
                                <Alert severity="error">Server Error! New device was not added!</Alert>
                            ) : error1 ? (
                                <Alert severity="error">{responseMessage}</Alert>
                            ) : warning1 ? (
                                <Alert severity="warning">"Device added Successfully, but it's not reachable!"</Alert>
                            ) : success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                                    "All set! The device registration was successful."
                                </Alert>
                            ) : null}
                                    <input
                                        type="text"
                                        name="deviceName"
                                        placeholder="Group Name *"
                                        value={deviceName}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    />
                                    <select
                                        name="deviceType"
                                        title="If you cannot find a device type, contact the admin"
                                        value={deviceType}
                                        onChange={this.handleInputChange}
                                        style={{ width: '100%', padding: '8px', fontSize:'13px' }}
                                    >
                                        <option value="" disabled>Select Device Type *</option>
                                        {device_type_list.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.type_name}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        name="client"
                                        value={client}
                                        onChange={this.handleInputChange}
                                        style={{ width: '100%', padding: '8px', fontSize:'13px', color:'black' }}
                                    >
                                        <option value="" disabled>Select Site *</option>
                                        {(site_list && Array.isArray(site_list)) ? (
                                            site_list.map((client) => (
                                                <option key={client.id} value={client.id}>
                                                    {client.sitename}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>No sites available</option>
                                        )}
                                    </select>
                                    <div>
                                    <input
                                        type="text"
                                        name="ipAddress"
                                        placeholder="IP Address *"
                                        value={ipAddress}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    />
                                    <input
                                        type="text"
                                        name="rtsp_port"
                                        placeholder="RTSP Port Number*"
                                        value={rtsp_port}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    /></div>
                                    <select
                                        name="protocol"
                                        value={protocol}
                                        onChange={this.handleInputChange}
                                        style={{ width: '100%', padding: '8px', fontSize:'13px' }}
                                    >
                                    <option value="" disabled>Select Server Protocol *</option>
                                    <option value="HTTP://">HTTP:// Protocol</option>
                                    <option value="HTTPS://">HTTPS:// Protocol</option>
                                    </select>
                                    <input
                                        type="text"
                                        name="portNumber"
                                        placeholder="Server Port Number *"
                                        value={portNumber}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    />
                                    <input
                                        type="text"
                                        name="deviceUsername"
                                        placeholder="Device Username *"
                                        value={deviceUsername}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    />
                                    <input
                                        type="password"
                                        name="devicePassword"
                                        placeholder="Device Password *"
                                        value={devicePassword}
                                        onChange={this.handleInputChange}
                                        style={{ width: '98%'}}
                                    />
                                <button type="button" 
                                    onClick={this.handleSubmit} 
                                    >
                                    Add Device
                                </button>
                            {/* Backdrop with Circular Progress */}
                            <Backdrop open={this.state.open_progress_bar}>
                            {/* <CircularProgress size={80} color="inherit" /> */}
                            <div className="custom-spinner">
                                <div className="circle"></div>
                                <div className="circle tilted"></div>
                                <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                            </div>
                            </Backdrop>
                        </div>
                        {showModal && (
                        <div className="modal-device-add">
                            <div className="modal-content">
                                <button className="close-button" onClick={this.handleCloseModal}>
                                    &times;
                                </button>
                                <h3>{responseMessage}</h3>

                                {response_data && typeof response_data === "object" ? (
                                    <div>
                                        {/* Render Device Info */}
                                        {response_data.device_info && (
                                            <div>
                                            <h4>Device Info</h4>
                                            <ul>
                                                {Object.entries(response_data.device_info).map(([key, value]) => (
                                                    <li key={key}>
                                                        <strong>{key.replace(/_/g, " ")}:</strong> <span style={{ color: value ? "green" : "red",}}> {value?.toString() || "N/A"}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                                    {/* Render Disk Info */}
                                    {response_data.disk_info && (
                                        <div>
                                            <h4>Disk Info</h4>
                                            <ul>
                                                {Object.entries(response_data.disk_info).map(([key, value]) => (
                                                    <li key={key}>
                                                        <strong>{key.replace(/_/g, " ")}:</strong> <span style={{ color: value ? "green" : "red",}}> {value?.toString() || "N/A"}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                                    {/* Render Channel List */}
                                    {response_data.channel_list && response_data.channel_list.length > 0 && (
                                        <div>
                                            <h4>Channel List</h4>
                                            <ul>
                                                {response_data.channel_list.map((channel, index) => (
                                                    <li key={index}>
                                                        <strong>Channel ID:</strong> {channel.channel_id || "N/A"} <br />
                                                        <strong>Status:</strong> 
                                                            <span style={{ color: channel.channel_status === "offline" || !channel.channel_status ? "red" : "green"}} >
                                                                {channel.channel_status || "N/A"}
                                                            </span> <br />
                                                        <strong>Name:</strong> {channel.name || "N/A"} <br />
                                                        {/* <strong>Recording Type:</strong>
                                                        <span style={{ color: !channel.recording_type ? "red" : "green"}} >
                                                                {channel.recording_type || "N/A"}
                                                        </span> <br /> */}
                                                        {/* <strong>Recording Status:</strong>
                                                        <span style={{color: channel.recording_status === "no recording" || !channel.recording_status ? "red" : "green"}} >
                                                                {channel.recording_status || "N/A"}
                                                            </span> <br /> */}
                                                        <strong>Resolution:</strong> 
                                                            <span style={{color: !channel.resolution ? "red" : "green"}} >
                                                                {channel.resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Main Stream Resolution:</strong> 
                                                            <span style={{color: !channel.main_stream_resolution ? "red" : "green"}} >
                                                                {channel.main_stream_resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Substream Resolution:</strong> 
                                                            <span style={{color: !channel.sub_stream_resolution ? "red" : "green"}} >
                                                                {channel.sub_stream_resolution || "N/A"}
                                                            </span><br/>
                                                        <strong>Substream FPS:</strong> 
                                                            <span style={{color: !channel.sub_stream_fps ? "red" : "green"}} >
                                                                {channel.sub_stream_fps || "N/A"}
                                                            </span><br/>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                        
                        
                                    {/* Render Snapshot Info */}
                                    {response_data.snapshot_info && response_data.snapshot_info.length > 0 && (
                                        <div>
                                            <h4>Snapshot Info</h4>
                                            <ul>
                                                {response_data.snapshot_info.map((snapshot, index) => (
                                                    <li key={index} style={{ color: "green"}}>{snapshot}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {response_data.time_zone_match !== undefined && (
                                        <div>
                                            <h4>Timezone Info</h4>
                                            <ul>
                                                <li 
                                                    key="site_time_zone" 
                                                    style={{ color: response_data.time_zone_match ? "green" : "red" }}
                                                >
                                                    Site Timezone: {response_data.site_time_zone}
                                                </li>
                                                <li 
                                                    key="device_time_zone" 
                                                    style={{ color: response_data.time_zone_match ? "green" : "red" }}
                                                >
                                                    Device Timezone: {response_data.device_time_zone}
                                                </li>
                                                
                                            </ul>
                                        </div>
                                    )}


                                </div>
                                ) : (
                                    <p>No additional details available.</p>
                                )}
                            </div>
                        </div>
                        )}

            
                    </div>
                </div>
            </div>
        );
    }
}

export default AddDevice;
